import React, { useState, useEffect } from "react";
import Navbar from "../../components/header/Header";
import { TabView, TabPanel } from "primereact/tabview";
import ProjectInfo from "./components/ProjectInfo";
import "./CreateProject.css";
import Measurement from "./components/Measurement";
import DeviceMessaging from "./components/DeviceMessaging";
import ServerMessaging from "./components/ServerMessaging";
import Transfer from "./components/Transfer";
import AssignDevices from "./components/Assign";
import ProjectService from "../all-projects/ProjectService";
import { useNavigate } from "react-router-dom";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

const CreateProject = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [userDetails, setUserDetails] = useState<any>([]);
  const [measurementDisabled, setMeasurementDisabled] = useState<boolean>(true);
  const [deviceMessagingDisabled, setDeviceMessagingDisabled] =
    useState<boolean>(true);
  const [serverMessagingDisabled, setServerMessagingDisabled] =
    useState<boolean>(true);
  const [transferDisabled, setTransferDisabled] = useState<boolean>(true);
  const [assignDisabled, setAssignDisabled] = useState<boolean>(true);

  const projectService = new ProjectService();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);

    projectService
      .getUserDetails()
      .then((response) => setUserDetails(response));
  }, [i18n.language]);

  return (
    <>
      <Navbar userDetails={userDetails} />

      <div className="grid mt-5" id="tabs">
        <div className="col-12">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="form_tabs"
          >
            <TabPanel header={t("project_info")} leftIcon="pi pi-info">
              <ProjectInfo
                onNext={() => {
                  setActiveIndex(1);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("measurements")}
              leftIcon="pi pi-database"
              disabled={measurementDisabled}
            >
              <Measurement
                onPrevious={() => {
                  setActiveIndex(0);
                }}
                onNext={() => {
                  setMeasurementDisabled(false);
                  setActiveIndex(2);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("device_messaging")}
              leftIcon="pi pi-comment"
              disabled={deviceMessagingDisabled}
            >
              <DeviceMessaging
                onPrevious={() => {
                  setActiveIndex(1);
                }}
                onNext={() => {
                  setDeviceMessagingDisabled(false);
                  setActiveIndex(3);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("server_messaging")}
              leftIcon="pi pi-comment"
              disabled={serverMessagingDisabled}
            >
              <ServerMessaging
                onPrevious={() => {
                  setActiveIndex(2);
                }}
                onNext={() => {
                  setServerMessagingDisabled(false);
                  setActiveIndex(4);
                }}
              />
            </TabPanel>
            <TabPanel
              header={t("transfer_other")}
              leftIcon="pi pi-check-circle"
              disabled={transferDisabled}
            >
              <Transfer
                onPrevious={() => {
                  setActiveIndex(3);
                }}
                onNext={() => {
                  setTransferDisabled(false);
                  setActiveIndex(5);
                }}
              />
            </TabPanel>

            <TabPanel
              header={t("assign_devices")}
              leftIcon="pi pi-list"
              disabled={assignDisabled}
            >
              <AssignDevices
                userId={userDetails["id"]}
                onNext={() => {
                  setTimeout(function () {
                    navigate("/");
                  }, 3000);
                }}
              />
            </TabPanel>
          </TabView>
        </div>
      </div>
    </>
  );
};

export default CreateProject;
